import styled from 'styled-components';

export const Wrapper = styled.div<{ visibility: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  visibility: ${({ visibility }) => (visibility ? 'visible' : 'hidden')};
  pointer-events: ${({ visibility }) => (visibility ? 'auto' : 'none')};
`;

export const TextWrapper = styled.div`
  font-weight: 600;
`;
